import React from 'react';
import { CheckSquare, Clock, AlertTriangle, Globe } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  delayFactors
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-blue-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Учет пересадок */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeLayover"
              checked={formData.includeLayover}
              onChange={handleInputChange}
              className="form-checkbox"
              disabled={formData.flightType === 'direct'}
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать пересадку
            </span>
          </label>
          {formData.flightType === 'direct' && formData.includeLayover && (
            <p className="mt-1 text-xs text-amber-600 dark:text-amber-400">
              <AlertTriangle className="w-3 h-3 inline mr-1" />
              Пересадки доступны только для маршрутов с соединением.
            </p>
          )}
        </div>

        {/* Учет задержек */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeDelays"
              checked={formData.includeDelays}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать типичные задержки
            </span>
          </label>
        </div>

        {/* Фактор задержки (если включен учет задержек) */}
        {formData.includeDelays && (
          <div>
            <label htmlFor="delayFactor" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Clock className="w-4 h-4 mr-2 text-amber-500" />
              Уровень загруженности
            </label>
            <select
              id="delayFactor"
              name="delayFactor"
              value={formData.delayFactor}
              onChange={handleInputChange}
              className="form-select w-full"
            >
              {delayFactors.map((factor) => (
                <option key={factor.id} value={factor.id}>
                  {factor.name} (+{Math.round(factor.value * 100)}% ко времени)
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Учет часовых поясов */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeTimezones"
              checked={formData.includeTimezones}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Globe className="w-4 h-4 mr-1 text-blue-500" />
              Учитывать часовые пояса
            </span>
          </label>
        </div>
      </div>

      {/* Информационный блок о задержках */}
      {formData.includeDelays && (
        <div className="mt-4 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
          <div className="flex items-start">
            <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1" />
            <div>
              <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
                Информация о задержках
              </h4>
              <p className="text-xs text-amber-600 dark:text-amber-400">
                Низкий уровень загруженности: межсезонье, будние дни.<br />
                Средний уровень: выходные, высокий сезон.<br />
                Высокий уровень: праздники, пиковые даты отпусков.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalParametersSection;